import { SprayEventOperatorsIndex } from 'services/sprayEvents/types';
import { SetSprayEventMultipleOperatorsTabIndexAction } from './types';
import { SPRAY_EVENT_MULTIPLE_OPERATORS_TAB_SET_ACTIVE_INDEX } from './constants';

export function setSprayEventMultipleOperatorsTabIndex(
    activeIndex: SprayEventOperatorsIndex
): SetSprayEventMultipleOperatorsTabIndexAction {
    return {
        type: SPRAY_EVENT_MULTIPLE_OPERATORS_TAB_SET_ACTIVE_INDEX,
        payload: activeIndex
    };
}
